import firestore from 'firebase/firestore';
import { BasketsSold } from './BasketsSold';
import { OrderSatisfaction } from './OrderSatisfaction';
import { PartnerProducer } from './PartnerProducer';

export class Paniers {
    idPanier?: string;

    idProducteur?: string;

    titre?: string;

    poids?: number = 0;

    prix?: number = 0;

    quantite?: number = 0;

    photoUrl?: string[] | File[];

    detail?: string;

    estPublie?: boolean;

    satisfaction?: OrderSatisfaction[];

    paniersVendus?: BasketsSold[];

    ventes?: number = 0;

    producteurPartenaire?: PartnerProducer[];

    estSupprime?: boolean;

    constructor({
        idPanier,
        idProducteur,
        titre,
        poids,
        prix,
        quantite,
        photoUrl,
        detail,
        estPublie,
        satisfaction,
        paniersVendus,
        ventes,
        producteurPartenaire,
        estSupprime
    }: {
        idPanier?: string;
        idProducteur?: string;
        titre?: string;
        poids?: number;
        prix?: number;
        quantite?: number;
        photoUrl?: string[] | File[];
        detail?: string;
        estPublie?: boolean;
        satisfaction?: OrderSatisfaction[];
        paniersVendus?: BasketsSold[];
        ventes?: number;
        producteurPartenaire?: PartnerProducer[];
        estSupprime?: boolean;
    }) {
        this.idPanier = idPanier;
        this.idProducteur = idProducteur;
        this.titre = titre;
        this.poids = poids;
        this.prix = prix;
        this.quantite = quantite;
        this.photoUrl = photoUrl;
        this.detail = detail;
        this.estPublie = estPublie;
        this.satisfaction = satisfaction;
        this.paniersVendus = paniersVendus;
        this.ventes = ventes;
        this.producteurPartenaire = producteurPartenaire;
        this.estSupprime = estSupprime;
    }
}

export const PaniersConverter: firestore.FirestoreDataConverter<Paniers> = {
    toFirestore(paniers) {
        return {
            idPanier: paniers.idPanier,
            idProducteur: paniers.idProducteur,
            titre: paniers.titre,
            poids: paniers.poids,
            prix: paniers.prix,
            quantite: paniers.quantite,
            photoUrl: paniers.photoUrl,
            detail: paniers.detail,
            estPublie: paniers.estPublie,
            satisfaction: paniers.satisfaction,
            paniersVendus: paniers.paniersVendus,
            ventes: paniers.ventes,
            producteurPartenaire: paniers.producteurPartenaire,
            estSupprime: paniers.estSupprime
        };
    },
    fromFirestore(snapshot, options): Paniers {
        const data = snapshot.data(options);
        return new Paniers({
            idPanier: data.idPanier,
            idProducteur: data.idProducteur,
            titre: data.titre,
            poids: data.poids,
            prix: data.prix,
            quantite: data.quantite,
            photoUrl: data.photoUrl,
            detail: data.detail,
            estPublie: data.estPublie,
            satisfaction: data.satisfaction,
            paniersVendus: data.paniersVendus,
            ventes: data.ventes,
            producteurPartenaire: data.producteurPartenaire,
            estSupprime: data.estSupprime
        });
    }
};
